var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-flex ml-3"},[(_vm.order == 'asc')?[_vm._t("vbt-sort-asc-icon")]:(_vm.order === 'desc')?[_vm._t("vbt-sort-desc-icon")]:[_vm._t("vbt-no-sort-icon")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }